import type * as React from "react";
import { cn } from "../../lib/utils.ts";

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Selected state. */
  on?: boolean;
  /** Selected accent — gold (default) or lime "cheers". */
  tone?: "gold" | "lime";
}

/** Pill toggle used for filters, status tags, and preset messages. */
export function Chip({
  on = false,
  tone = "gold",
  className,
  type = "button",
  ...props
}: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={on}
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 font-medium text-[0.82rem] transition-all duration-150",
        !on && "border-hairline bg-[oklch(100%_0_0_/_5%)] text-cream-2",
        on &&
          tone === "gold" &&
          "border-[oklch(79%_0.12_80_/_50%)] bg-[linear-gradient(180deg,oklch(79%_0.12_80_/_22%),oklch(79%_0.12_80_/_10%))] text-gold-soft",
        on &&
          tone === "lime" &&
          "border-[oklch(86%_0.18_120_/_45%)] bg-[linear-gradient(180deg,oklch(86%_0.18_120_/_20%),oklch(86%_0.18_120_/_8%))] text-lime",
        className,
      )}
      {...props}
    />
  );
}
